import { PowerResourceType } from '@/contract/map.base'

export const getResourceIconByType = (type: string, size = 16, color = '#040B29') => {
  return (
    <>
      {type === PowerResourceType.ServiceCenter ? (
        <ns-icon name={(process.config as any).icon.icon_service} color={color} size={size} />
      ) : type === PowerResourceType.TestDrive ? (
        <ns-icon name="test-drive-point-xs" color={color} size={size} />
      ) : type === PowerResourceType.NioHouse ? (
        <ns-icon name={(process.config as any).icon.nio_house} color={color} size={size} />
      ) : type === PowerResourceType.NioSpace ? (
        <ns-icon name={(process.config as any).icon.nio_space} color={color} size={size} />
      ) : type === PowerResourceType.NioRoadShow ? (
        <ns-icon name="nio-road-show-xs" color={color} size={size} />
      ) : type === PowerResourceType.PowerSwap ? (
        <ns-icon name={(process.config as any).icon.power_swap} color={color} size={size} />
      ) : type === PowerResourceType.ThirdChargeStation ? (
        <ns-icon
          name={(process.config as any).icon.icon_third_charge_station}
          color={color}
          size={size}
        />
      ) : type === PowerResourceType.NioChargeStationNpc ? (
        <ns-icon
          name={(process.config as any).icon.icon_nio_charge_station_npc}
          color={color}
          size={size}
        />
      ) : type === PowerResourceType.NioChargeStationDest ? (
        <ns-icon
          name={(process.config as any).icon.icon_nio_charge_station_dest}
          color={color}
          size={size}
        />
      ) : (
        <ns-icon name={(process.config as any).icon.address_2xs} color={color} size={size} />
      )}
    </>
  )
}

export const getPowerIcon = (type: string, className = '', size = 22) => {
  switch (type) {
    case PowerResourceType.PowerSwap:
      // 换电站
      return (
        <ns-icon
          name={(process.config as any).icon.icon_power_swap}
          color="#295279"
          size={size}
          class={className}
        />
      )
    case PowerResourceType.NioChargeStationNpc:
      // 超充站
      return (
        <ns-icon
          name={(process.config as any).icon.super_charge_station_v2}
          color="#79A0C5"
          size={size}
          class={className}
        />
      )
    case PowerResourceType.NioChargeStationDest:
      // 目的地充电站
      return (
        <ns-icon
          name={(process.config as any).icon.charge_station_dest_v2}
          color="#79A0C5"
          size={size}
          class={className}
        />
      )
    case PowerResourceType.ThirdChargeStation:
      // 三方充电桩
      return (
        <ns-icon
          name={(process.config as any).icon.third_charge_station_v2}
          color="#B5C6D9"
          size={size}
          class={className}
        />
      )
    default:
      return <div class={className}></div>
  }
}
